define('SC.HashtagGallery.1.0.0.HashtagGallery', [
    'underscore',
    'HashtagGallery.ItemDetails.View',
    'SC.Configuration'
], function HashtagGallery(
    _,
    HashtagGalleryItemDetails,
    Configuration
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            var moduleConfig = Configuration.get('hashtagGallery');
            var pdp = application.getComponent('PDP');
            application.Configuration.hashtagGallery = moduleConfig;

            pdp.addChildViews(
                pdp.PDP_FULL_VIEW, {
                    'ProductReviews.Center': {
                        'ProductDetails.HashtagGallery': {
                            childViewIndex: 20,
                            childViewConstructor: function childViewConstructor() {
                                return new HashtagGalleryItemDetails({
                                    application: application,
                                    pdp: pdp,
                                    hashtags: pdp.getItemInfo().item.custitem_ef_smh_social_media_hashtag
                                });
                            }
                        }
                    }
                }
            );
        }
    };
});
